import _ from 'lodash';
import React, { createContext, useContext, useEffect, useMemo, useReducer, useState } from 'react';
import { Button, Label, Menu, Sidebar } from 'semantic-ui-react';
import { FrameworkContext } from '../../cnr/contexts/FrameworkContent';
import { ParentContext } from '../../cnr/contexts/ParentContext';
import { UiItemContext } from '../../cnr/contexts/UiItemContext';
import { imageMapHandlers, imageMapInitialState, imageMapReducer } from '../../cnr/reducers/ImageMapReducer';
import { getFirstObject } from '../../common/convert';
import { uniqueKey } from '../../common/keys';
import { gEnums } from '../../enums/globalEnums';
import UiCreateGlobalData from '../../pageItem/modification/dataManagement/UiCreateGlobalData';
import { DataModificationsContext } from '../../pageItem/modification/UiDataModifications';
import { appDataActionTypes } from '../../viewSettings/enums/itemActionTypes';
import FullPageWrapper from '../../wrappers/FullPageWrapper';
import Wrapper, { wrapperTypes } from '../../wrappers/Wrapper';
import WrapperVertCols from '../../wrappers/WrapperVertCols';
import UiSaveButtons from '../buttons/UiSaveButtons';
import DataSidebar from '../swipers/DataSidebar';
import UploaderWithProvider from '../uploading/Uploader';
import ThumbSwipe from './ThumbSwipe';
import DropdownOptionsMenu from '../forms/elements/DropdownOptionsMenu';
import { openExternal } from 'global/viewSettings/helpers/settingsLinks';
import { useLocationMapping } from 'global/cnr/contexts/useHelpers/useLocationMapping';

// const url = 'https://i.pinimg.com/736x/7f/92/62/7f9262868a0a7aa99684aa04239cde49--home-floor-plans-large-house-floor-plans.jpg'

const _zoneCollectionName = '_zones'
const _useAppDataDocuments = true
const _defaultLocationKey = 'locations'

const _menuSize = 'small'

export const ImageMapContext = createContext();

/**
 * 
 * @param {object} props 
 * @returns A sidebar (imageMap, locations, zones )
 */
const ImageMapping = (props) => {

  const parentContext = useContext(ParentContext);
  const { states, fns } = parentContext ?? {}
  const { paps_state, currentSettings_state, eventInfo_state, storage_state } = states
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { imageMapping: imageMapping_global } = aps_global ?? {}
  const { locationProps } = imageMapping_global ?? {}

  const { storage_fns, database_fns } = fns

  // papsContext  
  const { pathViews } = paps_state

  // storageContext 
  const { appStorageUrlFiles } = storage_state ?? {}
  const { floormap: floorMapFiles } = appStorageUrlFiles ?? {}
  const floorMapFileKeys = floorMapFiles ? Object.keys(floorMapFiles) : []

  // frameworkContext
  const frameworkContext = useContext(FrameworkContext);
  const { framework_state } = frameworkContext ?? {}
  const { frInfo, frameworkRightType } = framework_state ?? {}
  const { viewListData: vld_fr, viewItem: viewItem_fr } = frInfo ?? {}

  const dataModificationsContext = useContext(DataModificationsContext)
  const { dataModifications_state, dataModifications_handlers } = dataModificationsContext ?? {}
  const { appData, viewItem: viewItem_dm } = dataModifications_state ?? {}

  // uiItemContext
  const uiItemContext = useContext(UiItemContext);
  const { item_handlers, item_state } = uiItemContext ?? {}
  const { vld, viewItem, modifyMapPropKey } = item_state ?? {}
  const { handleShow_modifyMapping } = item_handlers ?? {}
  const { key: uivi } = viewItem ?? {}

  // pageContext  
  const imageMapping_vi = imageMapping_global ? _.find(imageMapping_global, { collectionName: uivi }) : {}
  const { mapFieldName: mapFieldName_vi } = imageMapping_vi ?? {}
  const _mapFieldName = 'locations' // mapFieldName_vi ? mapFieldName_vi : modifyMapPropKey

  const { appGlobalData, appDataDocuments, appZoneData } = eventInfo_state ?? {}
  const _globalLocationKeys = appGlobalData ? Object.keys(appGlobalData) : []

  const { item: itemData } = vld ? getFirstObject(vld) : {}
  const { name: name_item } = itemData ?? {}
  const itemLocation = itemData ? itemData[_mapFieldName] : null

  // imageMap_state
  const [imageMap_state, imageMap_dispatch] = useReducer(imageMapReducer, imageMapInitialState({
    appGlobalData,
    collectionName: _zoneCollectionName,
    // database_fns,
    globalLocationKeys: _globalLocationKeys,
    imageMapType: props.imageMapType ? props.imageMapType : gEnums.imageMapTypes.zoneMapping,
    isItemMapping: props.imageMapType === gEnums.imageMapTypes.itemMapping,
    itemLocation,
    locationProps,
    mapFieldName: _mapFieldName,
    pathViews,
    showZoneHeader: props.imageMapType === gEnums.imageMapTypes.itemLocation,
    // storage_fns,
    _zonedFloormaps: appZoneData,
    appStorageUrlFiles
  }));

  const imageMap_handlers = imageMapHandlers(imageMap_dispatch, imageMap_state)
  const {
    _zonedFloormaps,
    currentFloormap,
    currentLocation,
    currentZone,
    currentZones,
    floormapUrl,
    imageMapType,
    locationName,
    locationsData,
    isItemMapping,
    showZoneHeader,
    selectedLocationProp,
    selectedLocationData,
    selectedGlobalData,
    appDataDoc,
  } = imageMap_state ?? {}

  const { name: name_location } = currentLocation ?? {}

  const _hasZones = currentZones && Object.keys(currentZones).length > 0
  const _url = floormapUrl ? floormapUrl : null

  const [showMessage, setShowMessage] = useState()
  const [showUpload, setShowUpload] = useState()
  const [showUpdateLocations, setShowUpdateLocations] = useState()

  const _locationsOk = selectedLocationData && selectedGlobalData && (Object.keys(selectedLocationData).length === Object.keys(selectedLocationData).length)

  // const zzz = useImage({ imageMapType, itemLocation })


  const { updateFieldDataToDb, updateZonesToDb, updating } = useLocationMapping()

  const handleShowUpload = () => setShowUpload(!showUpload)
  const handleShowUpdateLocations = () => setShowUpdateLocations(!showUpdateLocations)

  const currentUrls = useMemo(() => {
    const filez = floorMapFiles?.[currentFloormap]
    return { ...filez }
  }, [currentFloormap])

  useEffect(() => {
    if (!_.isEmpty(locationsData)) {
      switch (imageMapType) {
        case gEnums.imageMapTypes.itemMapping:
          const mfn = _defaultLocationKey
          const _locationData = locationsData && locationsData[mfn] ? locationsData[mfn] : {}

          imageMap_handlers.handleSet_selectedLocationKey(mfn)
          imageMap_handlers.handleSet_selectedLocationData(_locationData)

          const { item } = getFirstObject(appData)
          const _itemLocation = item && item[_defaultLocationKey]
          const _itemLocationKey = _itemLocation && _itemLocation[0]

          if (_locationData && _itemLocationKey && _locationData[_itemLocationKey]) {
            const _locationDataItem = _locationData[_itemLocationKey]
            imageMap_handlers.handleSet_currentLocation(_locationDataItem)
          }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [locationsData, imageMapType]);

  // load the locations
  useEffect(() => {
    const _appDataDocument = _useAppDataDocuments && appDataDocuments?.[_mapFieldName]
    if (_appDataDocument) {
      imageMap_handlers.handleInit_imageMap(_appDataDocument, appGlobalData?.locations, appZoneData)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, []);

  useEffect(() => {
    if (_zonedFloormaps && floormapUrl) {
      imageMap_handlers.handleChange_floormapUrl()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [_zonedFloormaps, floormapUrl]);

  // sets up the menus (mapping and zones only)
  useEffect(() => {
    if (!_.isEmpty(selectedGlobalData)) {
      const _staticLocations = appDataDocuments ? appDataDocuments[_mapFieldName] : {}
      let _locationName;
      if (_.isArray(itemLocation)) {
        const _locationKey = itemLocation[0]
        const staticLocation = _staticLocations ? _staticLocations[_locationKey] : null
        if (staticLocation) {
          _locationName = staticLocation.name
        }
      } else {
        if (_staticLocations && itemLocation && _staticLocations[itemLocation]) {
          _locationName = _staticLocations[itemLocation].name
        }
      }
      imageMap_handlers.handleAmmend_locationName(_locationName)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [selectedGlobalData, floorMapFiles]);

  useEffect(() => {
    switch (imageMapType) {
      case gEnums.imageMapTypes.locationMapping:
      case gEnums.imageMapTypes.zoneMapping:
        imageMap_handlers.handleGet_floormapImageFromStorage(currentFloormap)
        break;
      default:
      // nothing
    }
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [selectedGlobalData, _zonedFloormaps, currentFloormap]);

  useEffect(() => {
    switch (imageMapType) {
      case gEnums.imageMapTypes.itemLocation:
      case gEnums.imageMapTypes.itemMapping:
        if (_zonedFloormaps && selectedGlobalData && itemLocation) {
          imageMap_handlers.handleAmmend_location()
        }
        break;
      default:
      // nothing
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [selectedGlobalData, _zonedFloormaps]);

  // simple message
  useEffect(() => {
    if (showMessage) {
      setTimeout(() => {
        setShowMessage()
      }, 2000)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [showMessage]);

  const handleOption_floormap = (value) => {
    imageMap_handlers.handleSet_currentFloormap(value)
  }

  const handleSelect_locationProp = (locationProp) => imageMap_handlers.handleSet_selectedLocationData(locationProp)
  const handleClick_floormap = (floormap) => imageMap_handlers.handleSet_currentFloormap(floormap)
  const handleClick_location = (location) => imageMap_handlers.handleSet_currentLocation(location)
  const handleClick_removeZone = () => imageMap_handlers.handleRemove_zone()
  const handleClick_zone = (ce) => imageMap_handlers.handleSet_currentZone(ce)

  const handleClick_updateFieldDataToDb = () => updateFieldDataToDb({ imageMap_state })
  const handleClick_updateZonesToDb = () => updateZonesToDb({ imageMap_state })

  const handleOpen_globalDb = async () => {
    openExternal.db(pathViews, null, ['_globals'])
  }

  const thumbSwipe = () => currentFloormap ? <ImageMapContext.Provider value={{ imageMap_state, imageMap_handlers }}>
    {isItemMapping && menu_locationTypes()}
    <ThumbSwipe
      url={_url}
      handleZoneClick={handleClick_zone}
    />
  </ImageMapContext.Provider> : <div>Select Floormap</div>

  const saveButtons_mapping = () => {
    const btns = []
    currentZone && btns.push({ oc: handleClick_removeZone, caption: 'Remove Zone (' + currentZone.text + ')', icon: 'delete', color: 'red', fl: true, disabled: !currentZone })
    btns.push({ oc: handleClick_updateZonesToDb, caption: 'Update Zones (' + Object.keys(currentZones).length + ')', icon: 'save', disabled: !_hasZones })
    return <UiSaveButtons others={btns} />
  }

  const saveButtons_locations = () => {
    let caption = 'Update ' + _.startCase(selectedLocationProp)
    caption += ' (' + name_location + ' to ' + currentZone.zone + ')'
    const btns = []
    btns.push({ oc: handleClick_updateFieldDataToDb, caption: caption, icon: 'save', disabled: !_hasZones })
    return <UiSaveButtons others={btns} />
  }

  const buttons_locations = () => {
    const btns = []
    const _caption = 'Update ' + _.startCase(selectedLocationProp)
    btns.push({ oc: handleShowUpdateLocations, caption: _caption, icon: 'arrow right', color: _locationsOk ? 'blue' : 'green' })
    return <UiSaveButtons others={btns} />
  }

  const buttons_floormaps = () => {
    const btns = []
    btns.push({ oc: handleShowUpload, caption: 'Upload Image', icon: 'arrow right' })
    return <UiSaveButtons others={btns} />
  }

  const saveButtons = () => {
    switch (imageMapType) {
      case gEnums.imageMapTypes.zoneMapping:
        return saveButtons_mapping()
      case gEnums.imageMapTypes.itemMapping:
      case gEnums.imageMapTypes.locationMapping:
        return currentLocation && currentZone && saveButtons_locations()
      default:
      // nothing 
    }
  }

  const topButtons_floorMaps = () => <Button.Group size='mini' fluid >
    <Button primary={imageMapType === gEnums.imageMapTypes.zoneMapping} onClick={() => { imageMap_handlers.handleSet_imageMapType(gEnums.imageMapTypes.zoneMapping) }}>{_.startCase(gEnums.imageMapTypes.zoneMapping)}</Button>
    <Button.Or />
    <Button primary={imageMapType === gEnums.imageMapTypes.locationMapping} onClick={() => { imageMap_handlers.handleSet_imageMapType(gEnums.imageMapTypes.locationMapping) }}>{_.startCase(gEnums.imageMapTypes.locationMapping)}</Button>
  </Button.Group>

  const list_floormap = () => {
    const listItems = floorMapFileKeys ? floorMapFileKeys.map((key, index) => (<Menu.Item
      key={(uniqueKey('fm', index))}
      className={currentFloormap && currentFloormap === key ? 'sel' : null}
      onClick={() => { handleClick_floormap(key) }}>
      {key}
    </Menu.Item>)) : [{ name: 'No Floor Maps' }]
    return <Menu vertical secondary size={_menuSize} className='menu-vert-col'>
      {listItems}
    </Menu>
  }

  const menu_locationTypes = () => {
    const items = _.map(locationProps, (locationProp, index) => {
      return <Menu.Item
        key={(uniqueKey('lts', locationProp))}
        className={selectedLocationProp === locationProp ? 'sel' : null}
        onClick={() => { handleSelect_locationProp(locationProp) }}>
        {_.startCase(locationProp)}
      </Menu.Item>
    })
    return <Menu vertical secondary size={_menuSize} className='menu-vert-col'>
      {items}
    </Menu>
  }

  const menu_locations = () => {

    const _locations = selectedLocationData ? _.sortBy(selectedLocationData, 'name') : []

    // if (!selectedLocationData) {
    //   return <div>No Location Type Selected</div>
    // }


    const listItems = selectedGlobalData ? _locations.map((location, index) => {
      const { name, _itemKey } = location ?? {}
      const _location_mapped = _.find(selectedGlobalData, { name: name })
      const { zone } = _location_mapped ?? {}
      const { imageKey, zoneIndex } = zone ?? {}
      const _currentZone = currentZones ? currentZones['zone ' + zoneIndex] : {}
      const { text } = _currentZone ?? {}

      const _selected = (currentLocation?.name === name)

      return <Menu.Item
        key={(uniqueKey('loc', index))}
        className={_selected ? 'sel' : null}
        onClick={() => { handleClick_location(location) }}>
        <div>
          <div>{name}</div>
          <div>{imageKey ? imageKey : '-'}</div>
        </div>
        <div>
          <Label circular size={'tiny'} color={zoneIndex ? 'green' : 'grey'}>{text ? text : '-'}</Label>
        </div>
      </Menu.Item>

    }) : []

    return <Menu vertical secondary size={_menuSize} className='menu-vert-col'>
      {listItems}
    </Menu>
  }

  const footer_xxx = () => {

    const btns_e = []

    btns_e.push({ oc: handleOpen_globalDb, caption: 'Open Global DB', icon: 'arrow right', color: 'blue', fl: true })

    const ddom_e = <DropdownOptionsMenu
      menuButtons={btns_e}
      caption={'Open Actions'}
      color={'blue'}
      icon={'content'}
      float={'left'}
    />

    return ddom_e
  }

  const wrapper_floormap = () => <Wrapper
    header={'Floor Maps'}
    content={list_floormap()}
    footer={buttons_floormaps()}
    wrapperType={wrapperTypes.paddedHeaderAndFooter}
  />

  const wrapper_zones = () => <Wrapper
    header={currentFloormap ? 'Zones (' + currentFloormap + ')' : 'Zones'}
    content={currentFloormap && thumbSwipe()}
    footer={_hasZones && saveButtons()}
    wrapperType={wrapperTypes.padded}
    css={{ header: 'imt-' + imageMapType, footer: 'split', container: 'app-dark-mode' }}
  />

  const wrapper_locations = () => <Wrapper
    header={selectedLocationProp ? _.startCase(selectedLocationProp) : 'Select Location Type'}
    content={menu_locations()}
    footer={buttons_locations()}
    wrapperType={wrapperTypes.paddedHeaderAndFooter}
  />

  const wrapper_locationTypes = () => <Wrapper
    header={_.startCase('locationTypes')}
    content={menu_locationTypes()}
    footer={footer_xxx()}
    wrapperType={wrapperTypes.paddedHeaderAndFooter}
  />

  const zone_mapping = () => <WrapperVertCols mvc={'1-3'}>
    {wrapper_floormap()}
    {currentFloormap && wrapper_zones()}
  </WrapperVertCols>

  // image-mapping location
  const location_mapping = () => <WrapperVertCols mvc={'1-2-2-3'}>
    {wrapper_locationTypes()}
    {wrapper_locations()}
    {wrapper_floormap()}
    {wrapper_zones()}
  </WrapperVertCols>

  const fpw = () => <FullPageWrapper
    topperCaption={name_item}
    topperCaption2={locationName}
    content={wrapper_zones()}
    handleCancel={handleShow_modifyMapping}
  ></FullPageWrapper>

  const wrapper_sidebarRight = () => <Wrapper
    content={<UiCreateGlobalData
      appData={appDataDoc}
      inViewer={true}
      viewDataMode={appDataActionTypes.createGlobalData}
      viewKey={selectedLocationProp}
      callback={handleShowUpdateLocations}
    />}
    wrapperType={wrapperTypes.paddedHeader}
    css={{ container: 'data-sidebar' }}
  />

  const sidebar_right = (visible) => <DataSidebar
    direction={'right'}
    visible={visible}
    content={visible && wrapper_sidebarRight()}
    onHide={handleShowUpdateLocations}
  />

  const content = () => {
    switch (imageMapType) {
      case gEnums.imageMapTypes.zoneMapping:
        return zone_mapping()
      case gEnums.imageMapTypes.locationMapping:
        return location_mapping()
      case gEnums.imageMapTypes.itemLocation:
      case gEnums.imageMapTypes.itemMapping:
        return fpw()
      default:
        return zone_mapping()
    }
  }

  const topper = () => {
    if (_.isEmpty(appStorageUrlFiles) || _.isEmpty(_globalLocationKeys)) {
      let issues = ''
      if (_.isEmpty(appStorageUrlFiles)) {
        issues += 'No appStorageUrlFiles. '
      }
      if (_.isEmpty(_globalLocationKeys)) {
        issues += 'No globalLocationKeys. '
      }
      return issues
    }
    return;
  }

  const wrapper_content = () => <Wrapper
    header={isItemMapping ? name_location : topButtons_floorMaps()}
    topper={topper()}
    content={content()}
    wrapperType={wrapperTypes.paddedHeaderAndFooter}
    css={{ container: 'app-dark-mode' }}
  />

  const sidebar = () => <Sidebar.Pushable style={{ overflow: 'hidden' }}>
    {sidebar_right(showUpdateLocations)}
    <Sidebar.Pusher dimmed={showUpdateLocations} className='h100' >
      {wrapper_content()}
    </Sidebar.Pusher>
  </Sidebar.Pushable>

  if (showUpload) {
    return <UploaderWithProvider
      storageType={gEnums.storageTypes.floormap}
      storageLocationType={gEnums.storageLocationTypes.event}
      origin={'SingleImage'}
      useFull={true}
      handleCancel={handleShowUpload}
      showUpload={true} i
      mageMap_handlers={imageMap_handlers} />
  } else {
    return sidebar()
  }

}

export default ImageMapping